import type { VideoCallCartResponseDTO } from '../dto/videoCall.dto';
import type { VideoCallCartState } from '../../domain/models/VideoCallCart';

export function adaptVideoCallCartDtoToState(dto: VideoCallCartResponseDTO): VideoCallCartState {
  return {
    activeCount: typeof dto.activeVideoCallCount === 'number' ? dto.activeVideoCallCount : 0,
    message: dto.videoCallCartMessage ?? dto.message ?? '',
  };
}
